export class FacilityModel {
  constructor() {
    this.id = null;
    this.itemIndex = null;
    this.name = "";
    this.formattedAddress = "";
    this.facilityListings = [];
    this.geo = "";
    this.geoCoords = [];
    this.checked = false;
    this.storeCode = "";
    this.openStatus = null;
    this.locationState = {};
    this.processingInProgress = false;
    this.mapsIntegrationStatus = {};
  }

  makeFacilityModel({ facility, itemIndex }) {
    this._createModel({ facility, itemIndex });
  }

  returnFacilityModel() {
    return {
      id: this.id,
      itemIndex: this.itemIndex,
      name: this.name,
      formattedAddress: this.formattedAddress,
      businessType: this.businessType,
      facilityListings: this.facilityListings,
      geo: this.geo,
      geoCoords: this.geoCoords,
      checked: this.checked,
      storeCode: this.storeCode,
      openStatus: this.openStatus,
      locationState: this.locationState,
      processingInProgress: this.processingInProgress,
      mapsIntegrationStatus: this.mapsIntegrationStatus
    };
  }

  _createModel({ facility, itemIndex }) {
    this.id = facility.id;
    this.itemIndex = itemIndex;
    this.name = facility.name;
    this.formattedAddress = facility.formatted_address;
    this.businessType = facility.business_type;
    this.facilityListings = facility.facility_listings
      ? this._createFacilityListings(facility.facility_listings)
      : null;
    this.geo = facility.geo;
    this.geoCoords = facility.geo_coords;
    this.checked = false;
    this.storeCode = facility.store_code;
    this.openStatus = facility.open_status;
    this.locationState = facility.location_state;
    this.processingInProgress = facility.processing_in_progress;
    this.mapsIntegrationStatus = facility.maps_integration_status;
  }

  _createFacilityListings(facilityListings) {
    return {
      id: facilityListings.id,
      addressGroup: {
        id: facilityListings.address_group
          ? facilityListings.address_group.id
          : null,
        gmbAddressId: facilityListings.address_group
          ? facilityListings.address_group.gmb_address_id
          : null,
        osmAddressId: facilityListings.address_group
          ? facilityListings.address_group.osm_address_id
          : null
      },
      isOwner: facilityListings.is_owner
    };
  }
}
